import { useState, useEffect, useContext, useRef } from 'react';
import OrderedDataTable from './OrderedDataTableCopy.jsx';
import StandardRowFormatted from './StandardRowFormatted'; 
import InputDataTableDynamic from './InputDataTableDynamicCopy.jsx'; 
import InputTableRow from './InputTableRow';
import applyFormat from '../functions/applyFormat';
import copyObjArray from '../functions/copyObjArray';
import ApiRequestButton from './ApiRequestButton';
import copyObjectToArray from '../functions/copyObjectToArray';
import validateInputArray from '../functions/validateInputArray';
import dynamicValidation from '../functions/dynamicValidation';
import dynamicTransformation from '../functions/dynamicTransformation';
import { HttpContext } from '../../api-services/HttpService';
import CCOffcanvas from './CCOffcanvas.tsx';
import ButtonComponent from './ButtonComponent.jsx';

const ViewClawbacksModal = ({   
    viewClawbackModal, 
    setViewClawbackModal,
    clawbackDataList, 
    clawbackTableHeader, 
    showSpinner, 
    editButtonBool, 
    clawbackLists, 
    clawbackConfig, 
    snackbarAlert, 
    getRefreshData, 
    masterCompanyData, 
    incentiveSetupId, 
    companyId, 
    description
}) => {
    // initialize http context 
    const {
        PUT
    } = useContext(HttpContext);
    // initialize state
    const [values, setValues] = useState({}); 
    const [error, setError] = useState([{}]); 
    const [config, setConfig] = useState([]); 
    const [edit, setEdit] = useState(false); 
    // initialize refs 
    const oldValues = useRef({}); 


    // wrap row function in to pass to table for OrderedDataTable
    const RowComponent = ( row, count, tableHeader) => {
        return <StandardRowFormatted row={row} count={count} tableHeader={tableHeader} enableEdit={editButtonBool} />
    } 

    // wrap row function to pass to tanle for InputDataTable
    const InputRowComponent = ( data, setData, count, config, length, setLength ,addButtonText) => {
        return <InputTableRow data={data} setData={setData} count={count} config={config} length={length} setLength={setLength} lists={clawbackLists} error={error} setError={setError} addButtonText={addButtonText}/>
    }

    // assign default values 
    const assignDefaultValues = () => {
        // initialize values object 
        let objList = {}; 
        let tempError = []; 
        // add formatted objects 
        let clawbackDataListValues = copyObjArray(clawbackDataList);  
        for (let i = 0; i < clawbackDataListValues.length; i++) {
            let temp = applyFormat(clawbackDataListValues[i], clawbackConfig, clawbackLists, null); 
            temp['blank'] = false; 
            // add to object list 
            objList[i] = temp; 
            // add obj
            tempError.push({}); 
        }
        // add final object for add row 
        objList[clawbackDataListValues.length] = { blank: true }
        tempError.push({}); 
        // set state 
        setValues(values => values = objList); 
        setError(error => error = tempError); 
        // // set global variables 
        // let tempOldValues = copyObjectToArray(objList);
        // tempOldValues = tempOldValues.slice(0, tempOldValues.length-1);  
        // oldValues.current = [...tempOldValues]; 
        // set refs 
        oldValues.current = copyObjArray(clawbackDataList); 
    }

    // event handler for submit button click 
    const onSubmitClick = () => {
        return new Promise((resolve, reject) => {
            // run dynamic validation on input array
            let requestValuesClawback = copyObjectToArray(values); 
            // slice off blank row 
            requestValuesClawback = requestValuesClawback.slice(0, requestValuesClawback.length-1); 
            // validate input
            let checkError = validateInputArray(
                requestValuesClawback, 
                clawbackConfig,
                dynamicValidation,
                clawbackLists, 
                snackbarAlert,  
                error, 
                setError, 
                dynamicTransformation, 
                { }
            ); 
            // exit request if error 
            if (checkError) {
                reject(); 
                return; 
            }    
            console.log(requestValuesClawback); 
            // use PUT function to make request 
            PUT('/client/clawbacks', {
                mastercompanyid: masterCompanyData['mastercompanyid'], 
                incentivesetupid: incentiveSetupId,
                companyid: companyId, 
                ClawbackArgs: requestValuesClawback, 
                description: description, 
                oldValues: oldValues.current
            }).then(res => {
                // default edit state 
                setEdit(edit => edit = false); 
                // assign defaults 
                assignDefaultValues(); 
                // trigger success alert
                snackbarAlert(true, 'Successfully uploaded data.', 'success');
                // refresh CompanyDetailsPage using function from parent
                return getRefreshData();
            }).then(res => {
                console.log(res); 
                // resolve on success
                resolve(res); 
            }).catch(err => {
                console.log(err); 
                // show alert on error
                snackbarAlert(true, 'Error uploading data.', 'error');
                // reject on error
                reject(err); 
            }); 
        }); 
    }

    // useEffect to run on viewClawbackModal change
    useEffect(() => {
        setEdit(edit => edit = false); 
    }, [viewClawbackModal])

    // useEffect to run on config change 
    useEffect(() => {
        if (clawbackConfig) {
            // set config 
            setConfig(config => config = clawbackConfig); 
            if (clawbackDataList && clawbackLists) {
                // assign defaults 
                assignDefaultValues(); 
            }
        }
    }, [clawbackConfig, clawbackDataList, clawbackLists]); 

    return(
        <> 
            <CCOffcanvas 
                title='View Clawbacks'
                show={viewClawbackModal}
                onCanvasClose={()=>setViewClawbackModal(viewClawbackModal => viewClawbackModal = false)}
                bodyCssClassName="offcanvas-body bg-white"
                offCanvasClassName="offcanvas-parent-card"
                >
                <div className="d-flex flex-column h-100" >
                    {editButtonBool && <div className='d-flex justify-content-end w-100 bg-white p-3 pt-2 pb-2'>
                        <ButtonComponent key ={'Add/Edit'} tag='Add/Edit' onButtonClick={() => { setEdit(edit => edit = !edit) }} border={'#3D3D3D 1px solid'} background={'#3D3D3D'} color={'#FFFFFF'} width='max-content' />
                    </div>}
                    {edit ?
                        <>
                            <div className="p-3 trail-section flex-grow-1 overflow-scroll">
                                <div className="bg-white trail-card">
                                    <InputDataTableDynamic varHeight='210px' RowComponent={InputRowComponent} config={config} dataList={values} setDataList={setValues} showSpinner={showSpinner} skeletonHeight='14vh' addButtonText='Add Clawback' />
                                </div>
                            </div>
                            <div
                                className="d-flex justify-content-end p-3 w-100 offcanvas-footer z-2" style={{height: '65px'}}
                            >
                                <ButtonComponent key={"Cancel"} tag={"Cancel"}
                                    border={'#fcd800 1px solid'} background={'#fff'} color={'#001317'}
                                    onButtonClick={() => setViewClawbackModal(viewClawbackModal => viewClawbackModal = false)}
                                />
                                <ApiRequestButton onButtonClick={onSubmitClick} />
                            </div>
                        </>
                        :
                        <>
                            <div className="p-3 trail-section flex-grow-1 overflow-scroll">
                                <div className="bg-white trail-card">
                                    <OrderedDataTable sortingEnabled={true} varHeight='210px' RowComponent={RowComponent} tableHeader={clawbackTableHeader} dataList={clawbackDataList} showSpinner={showSpinner} numToPage={25} skeletonHeight='14vh' />
                                </div>
                            </div>
                            <div
                                className="d-flex justify-content-end p-3 w-100 offcanvas-footer z-2" style={{height: '65px'}}
                            >
                                <ButtonComponent
                                    key={"OK"}
                                    tag={"OK"}
                                    border={'#fcd800 1px solid'}
                                    background={'#fcd800'}
                                    color={'#001317'}
                                    onButtonClick={() => setViewClawbackModal(viewClawbackModal => viewClawbackModal = false)}
                                />
                            </div>
                        </>
                    }
                </div>
            </CCOffcanvas>
        </>
    );
}

export default ViewClawbacksModal; 